import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { removePicture } from "@routes/IconeSvg";
import { BLANK_PROFILE_PICTURE, REGEX_ALL_IMAGE } from "@helpers/_constants";
import { useNotification } from "@hooks/useNotification";
import Button from "@components/tailwindComponents/Button";

function readFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.readyState === 2) {
        resolve(reader.result);
      }
    };
    reader.onerror = reject;
  });
}

function TakePicture(props) {
  const { selectedImage, mainTranslator, readOnly, isMyProfile } = props;
  const { showError } = useNotification();
  const _allowUpdate = !readOnly || isMyProfile;
  
  const [showenImage, setShowenImage] = useState(null);

  useEffect(() => {
    refreshShowenImage(selectedImage);
  }, [selectedImage]);

  async function refreshShowenImage(selectedImage) {
    if (!selectedImage) {
      setShowenImage(null);
    } else if (typeof selectedImage === "string") {
      setShowenImage(selectedImage);
    } else if (selectedImage instanceof File) {
      const readedFile = await readFile(selectedImage);
      setShowenImage(readedFile);
    }
  }

  const onDrop = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file?.name?.match(REGEX_ALL_IMAGE)) {
      showError("please_enter_object_valid", { object: "file" });
      return;
    }

    props.onFileChange(file);
    await refreshShowenImage(file);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: "image/*",
    maxFiles: 1,
  });

  function removeImage() {
    setShowenImage(null);
    props.onFileChange(null);
  }

  return (
    <div
      className="arh-max-w-[15.5rem] arh-max-h-56 arh-w-full arh-py-6 arh-px-12 arh-bg-greyColor arh-rounded-[0.25rem] arh-relative arh-flex arh-flex-col arh-items-center arh-justify-center"
      {...getRootProps()}
    >
      { _allowUpdate && <input {...getInputProps()} /> }
      <div className="arh-w-[7.349rem] arh-h-[7.224rem] arh-rounded-full arh-overflow-visible arh-relative">
        <img
          alt=" "
          className="arh-w-full arh-h-full arh-object-cover arh-rounded-full"
          src={showenImage || BLANK_PROFILE_PICTURE}
        />
        {showenImage && (
          <div
            className="arh-absolute arh-top-1 arh-right-1 arh-p-1 arh-cursor-pointer arh-rounded-full"
            onClick={(e) => {
              e.stopPropagation();
              if (_allowUpdate)
                removeImage();
            }}
          >
            {_allowUpdate && removePicture()}
          </div>
        )}
      </div>
      { _allowUpdate && 
          <Button variant="green-outlined" className="arh-mt-4">
            {mainTranslator("Modifier la photo")}
          </Button>
      }
    </div>
  );
}

export default TakePicture;
